import {makeAutoObservable, reaction, toJS} from "mobx";
import {CategoryCompareManager} from "./CategoryCompareManager";
import type ProfileStore from "../../stores/ProfileStore";
import {AxoisRequestManager, RequestManager} from "../../stores/managers/RequestManager";
import type {AxiosResponse} from "axios";
import {from} from "rxjs";
import type {Bag} from "../../services/classes/Bag";
import type {MithraMaterializedApi} from "../../services/MithraMaterializedApi";
import type {MatCommonKpiSerializer} from "../../services/ApiTypes";

export class CompareBagStore {

    desiredMasterBagId?: number
    masterBag?: any
    masterBagNotFound = false;

    compareBag?: any
    compareBagNotFound = false;

    readonly cmpCat: CategoryCompareManager;
    readonly _bagRequestManager: RequestManager<{databag: number}, AxiosResponse<Bag>>;

    constructor(private api: MithraMaterializedApi, private profileStore: ProfileStore) {
        makeAutoObservable(this)
        this.cmpCat = new CategoryCompareManager(this.api, this.profileStore)
        this._bagRequestManager = new RequestManager<{databag: number}, AxiosResponse<Bag>>(
            ({databag}) => from(this.api.getBag(databag))
        );

        reaction(() => ([this._bagRequestManager.result?.data, this._bagRequestManager.error]), ([bag, err]) => {
            console.log('CompareBagStore: Setting master bag', toJS(bag), err);
            if (err) console.warn('CompareBagStore: Error while loading master bag: ' + err)
            if (bag) {
                this.masterBag = bag;
                this.masterBagNotFound = false;
            } else {
                this.masterBag = undefined;
                this.masterBagNotFound = true;
            }
        })
    }

    setMasterBag(bag: any) {
        this.masterBag = bag;
    }

    getMasterBag() {
        return this.masterBag
    }

    getMasterBagName() {
        return this.getMasterBag()?.name
    }

    setCompareBag(bag: any) {
        this.compareBag = bag;
    }

    getCmpBag() {
        return this.compareBag
    }

    getCmpBagName() {
        return this.getCmpBag()?.name;
    }

    initBags(desiredMasterBagId: number) {
        console.log('CompareBagStore: Init compare bags', desiredMasterBagId)
        this.desiredMasterBagId = desiredMasterBagId;
        if (this.masterBag || this.masterBagNotFound) {
            console.log('CompareBagStore: Init compare bags, skipped')
            // Databag is already present
            return;
        }
        if (isNaN(desiredMasterBagId)) {
            this.masterBagNotFound = true;
        } else {
            this._bagRequestManager.request({databag: desiredMasterBagId})
            this._masterKpiManager.request(desiredMasterBagId)
        }
    }

    setMissingMasterBag() {
        this.desiredMasterBagId = undefined;
        this.masterBagNotFound = true;
        this._bagRequestManager.cleanup();
        this.masterBag = undefined;
    }

    /**
     * Somewhat magical function to determine which is the master dataset, given some dataset
     * TODO: Very hacky, but it works for now
     * @param bag
     */
    determineMasterBag(bag: Bag | undefined | {id: number}): number | undefined | null {
        if (!bag) return undefined;
        const masterBagId = this.profileStore.p.hardcodeMasterBagId;
        if (!masterBagId) return undefined;
        if (bag.id === masterBagId) {
            console.warn('Warning: Master bag is the same as the selected bag...')
            // For demonstration purposes
            return masterBagId;
        }
        return masterBagId;
    }

    _masterKpiManager = new AxoisRequestManager<number, MatCommonKpiSerializer>(bagId => from(this.api.getCommonKpi(bagId)))

    get masterKpi() {
        return this._masterKpiManager.result;
    }
}
